// extracted by mini-css-extract-plugin
module.exports = {"alert":"StatusAlert_alert__2divX","warning":"StatusAlert_warning__1WA6C","success":"StatusAlert_success__3akdS","info":"StatusAlert_info__35qID"};